/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_08_27_13_13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EUnitType } from './eUnitType';


export interface TPostPutPlannedH2Amount { 
    facility_unit_typ_for_power_array?: EUnitType;
    facility_unit_typ_for_energy_array?: EUnitType;
    facility_values_power?: Array<number> | null;
    facility_values_energy?: Array<number> | null;
}

